<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="data2"
      :row-selection="Show ? rowSelection : undefined"
      :rowKey="(record) => record.key"
      :pagination="false"
      :scroll="height"
    >
      <!-- 题库题目 -->
      <template slot="questionIndex.question" slot-scope="text">
        <div :title="text" class="three-line">{{ text }}</div>
      </template>
      <!-- 消息中心 -->
      <template slot="particulars" slot-scope="item, row">
        <li
          @click="goParticulars(row)"
          style="
            color: #2eadb5;
            font-size: 14px;
            cursor: pointer;
            width: 700px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          "
          :title="item.strMessageName"
        >
          {{ item.strMessageName }}
        </li>
        <li
          @click="goParticulars(row)"
          style="
            color: #868484;
            font-size: 10px;
            cursor: pointer;
            width: 700px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          "
          :title="item.strMessageContent"
        >
          {{ item.strMessageContent }}
        </li>
        <!-- <li @click="goParticulars(row)" class="message-particulars" :title="item.strMessageContent">{{ item.strMessageContent }}</li> -->
      </template>
      <!-- 题型 -->
      <template slot="questiontypes" slot-scope="item">
        <div>
          {{ item | capitalize }}
        </div>
      </template>
      <template slot="state" slot-scope="item, row">
        <span :class="[item == '0' ? 'Unable' : 'Enable']" @click="power(row)">
          {{
            item == '0'
              ? $t('translateText.Personnelmanagement.Deactivate')
              : $t('translateText.Personnelmanagement.Enable')
          }}
        </span>
      </template>
      <!-- 时间 -->
      <template slot="time11" slot-scope="item">
        <div>
          {{ item.dtStartTime.slice(0, 10) }}至{{ item.dtEndTime.slice(0, 10) }}
        </div>
      </template>
      <!-- 评教 -->
      <template slot="iGrade" slot-scope="item, text, record, index">
        <div style="cursor:pointer" @click="through(text, record, index)">
          {{ text.iGrade }}
        </div>
      </template>
      <!-- 操作 -->
      <template slot="op" slot-scope="val, row, index">
        <div class="opState">
          <li v-if="viewSlide != ''" @click="showSlide(val, row, index)">
            {{ viewSlide }}
          </li>
          <li v-if="download != ''" @click="getfile(row)">
            {{ download }}
          </li>
          <li v-if="edit1 != ''" @click="update(row)">
            {{ edit1 }}
          </li>
          <li v-if="redact != ''" @click="showModal(val, row, index)">
            <!-- 资源中心 - 课程资料 - 编辑 -->
            {{ redact }}
          </li>
          <li v-if="del != ''">
            <a-popconfirm
              :title="title"
              placement="bottom"
              :ok-text="$t('translateText.ok')"
              :cancel-text="$t('translateText.cancel')"
              @confirm="delrole(row, index)"
              class="delete-prompt"
            >
              {{ del }}
            </a-popconfirm>
          </li>
          <li v-if="submit != ''" @click="submitDetail(row)">
            {{ submit }}
          </li>

          <li v-if="addto != ''" @click="addreceive(row)">
            {{ addto }}
          </li>
          <li v-if="enterinto != ''" @click="enter(row)">
            {{ enterinto }}
          </li>
          <!-- <li><a href="/src/assets\imgs\jiahao.png">{{ download }}</a></li> -->
        </div>
      </template>
      <!-- 评分星星 -->
      <template slot="star" slot-scope="item">
        <a-rate :default-value="2" :value="item" disabled allow-half />
      </template>
      <!-- 查看 -->
      <template slot="look" slot-scope="text, record, index">
        <!-- <iframe> -->
        <div class="through" @click="through(text, record, index)">
          {{ $t('translateText.kczl.ck') }}
        </div>
        <!-- </iframe> -->
      </template>
      <!-- 评教 -->
      <template slot="eval" slot-scope="item, text, record, index">
        <div class="through" @click="through(text, record, index)">
          {{
            item == '1'
              ? $t('translateText.StudentEvaluate.pj')
              : $t('translateText.StudentEvaluate.ck')
          }}
        </div>
      </template>
      <!-- 状态0|1 -->
      <template slot="status" slot-scope="item">
        <div :class="[item == '0' ? 'unread' : 'read']">
          {{
            item == '0'
              ? this.$t('translateText.StudentEvaluate.wd')
              : this.$t('translateText.StudentEvaluate.yd')
          }}
        </div>
      </template>
      <!-- 作业状态 0|1 -->
      <template slot="studystatus" slot-scope="item, row">
        <div
          @click="workinfo(row)"
          :class="[item == '0' ? 'unstudy' : 'study']"
        >
          {{
            item == '1'
              ? $t('translateText.table.wzd')
              : item == '2'
              ? $t('translateText.table.ywc')
              : $t('translateText.table.xq')
          }}
        </div>
      </template>
      <!-- 考试状态 0|1 -->
      <template slot="examstatus" slot-scope="item, row">
        <div
          @click="workinfo(row)"
          :class="[item == '0' ? 'unstudy' : 'study']"
        >
          {{
            item == '1'
              ? $t('translateText.table.wzd')
              : item == '2'
              ? $t('translateText.table.ywc')
              : $t('translateText.table.xq')
          }}
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    data2: {
      type: Array,
      default: () => [],
    },
    redact: {
      type: String,
      default: '',
    },
    edit1: {
      type: String,
      default: '',
    },
    del: {
      type: String,
      default: '',
    },
    submit: {
      type: String,
      default: '',
    },

    viewSlide: {
      type: String,
      default: '',
    },
    download: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    Show: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Object,
      default: () => {
        '{ y: 376 }'
      },
    },
    addto: {
      type: String,
      default: '',
    },
    enterinto: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectedRowKeys: [],
      arr1: [],
      selectedRows: [],
    }
  },
  filters: {
    capitalize: function(value) {
      if (value == 1) {
        return '单选题'
      } else if (value == 2) {
        return '多选题'
      } else if (value == 3) {
        return '判断题'
      } else if (value == 4) {
        return '填空题'
      } else if (value == 5) {
        return '简答题'
      } else if (value == 6) {
        return '实验标注题'
      } else if (value == 7) {
        return '实验简答题'
      }
    },
    //  dtStartTime:function(value){
    //      if (value == 1) {
    //         return "单选题";
    //     } else if (value == 2) {
    //         return "多选题";
    //     }
    // }
  },
  methods: {
    // 过滤字符串

    // filterTime(item){
    //     this.dtStartTime=item.dtStartTime.slice(0,14)
    //     // var dtStartTime=stringObject.slice(start,end)

    // },

    addreceive(row) {
      this.$emit('addreceive', row)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    goParticulars(row) {
      this.$emit('messageparticulars', row)
    },
    //切片浏览
    showSlide(val, row, index) {
      this.$emit('showSlide', val, row, index)
    },
    //下载
    getfile(row) {
      this.$emit('dcourse', row)
      // fetch(data)
      //     .then((res) => res.blob())
      //     .then((blob) => {
      //         // 将链接地址字符内容转变成blob地址
      //         const a = document.createElement("a");
      //         a.href = URL.createObjectURL(blob);
      //         a.download = fileName; // 下载文件的名字
      //         document.body.appendChild(a);
      //         a.click();
      //     });
    },
    //资源中心_编辑
    showModal(val, row, index) {
      this.$emit('editModal', val, row, index)
      // this.$parent.transition = true;
      this.$parent.visible = true
      this.$parent.transition = false
      this.$parent.headline = this.$t('translateText.kczl.bj')
    },
    //更新
    update(row) {
      // var id =
      //     e.currentTarget.parentElement.parentElement.parentElement
      //         .dataset.rowKey;
      this.$emit('update', row)
    },
    //提交详情
    submitDetail(row) {
      var id = row
      // e.currentTarget.parentElement.parentElement.parentElement
      //     .dataset.rowKey;
      this.$emit('submitDetail', id)
    },
    //删除角色
    delrole(row) {
      this.arr1 = []
      this.selectedRowKeys = []
      // this.data2.splice(index, 1);
      this.$emit('scope', row)
      //删除用户（用到用户姓名所以单写）
      this.arr1.push(row)
      this.$emit('usercheckAll', this.arr1)
      this.$emit('userscope')
    },
    //查看
    through(val, row, index) {
      this.$emit('through', val, row, index)
    },
    //进入班级
    enter(val, row, index) {
      this.$emit('enter', val, row, index)
    },
    //选择
    // onSelectChange(selectedRowKeys) {
    //     this.selectedRowKeys = selectedRowKeys;
    // },
    //启用 禁用
    power(row) {
      this.arr1 = []
      this.arr1.push(row)
      this.$emit('usercheckAll', this.arr1)
      if (row.status == 0) {
        this.$emit('receiveusing', '')
      } else {
        this.$emit('receiveisusing')
      }
    },
    //作业提交
    workinfo(row) {
      // var id = e.currentTarget.parentElement.parentElement.dataset.rowKey;
      this.$emit('workinfo', row)
    },
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys, selectedRows } = this
      return {
        selectedRowKeys,
        selectedRows,
        onChange: (selectedRowKeys, selectedRows) => {
          // 假设后台传入的唯一值叫key
          this.selectedRowKeys = selectedRowKeys
          let keys = selectedRows.map((item) => item.key)
          this.$emit('checkAll', keys)
          this.$emit('getSelected', selectedRowKeys)
          this.$emit('usercheckAll', selectedRows)
          this.selectedRowKeys = [...keys]
          this.selectedRows = []
        },
      }
    },
  },
}
</script>

<style lang="less" scoped>
.three-line {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
/deep/ .ant-table-wrapper {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
}
&/deep/ .ant-table-thead > tr > th {
  background-color: #e8e8e8;
}
&/deep/ .through {
  color: #f86b4f;
  cursor: pointer;
}
.opState {
  display: flex;
  color: #2eadb5;

  li {
    padding: 0 5px;
    border-right: 1px solid #c7c9c9;
    cursor: pointer;
  }
  li:last-child {
    border: unset;
  }
}
/deep/ .delete-prompt .ant-btn-primary {
  border: 0;
  background-color: #2eadb5;
}
/deep/ .ant-table-header {
  // overflow: hidden;
  background: #e8e8e8;
}
.read {
  color: #2eadb5;
  cursor: pointer;
}
.unread {
  color: #f9463f;
  cursor: pointer;
}
.state1 {
  text-align: center;
  width: 50%;
}
.Enable {
  padding: 3px 12px;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: #1aa97b;
  cursor: pointer;
}
.Unable {
  padding: 3px 12px;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: #f9463f;
  cursor: pointer;
}
/deep/ .ant-btn-primary {
  border: #2faeb6;
  background-color: #2faeb6;
}
/deep/ .ant-popover-inner-content {
  .ant-popover-buttons > button {
    background-color: #2faeb6;
  }
}
/deep/.ant-table-tbody > tr > td {
  padding: 9.5px 15px;
}
/deep/.ant-table-thead > tr > th {
  padding: 13px 15px;
}

&/deep/.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #2eadb5;
}

&/deep/.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #2eadb5;
  border-color: #2eadb5;
}
&/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #2eadb5;
}
.unstudy {
  cursor: pointer;
}
.study {
  cursor: pointer;
}
</style>
